<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ $t('bp.DeviceWarrantyStatus.title') }}</h1>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <label>{{ $t('bp.DeviceWarrantyStatus.purchaseDate') }} <span class="text-danger">*</span></label>
                            <div class="loading-input-container">
                                <input
                                        class="form-control"
                                        :disabled="checkingSelections"
										                    :placeholder="$t('bp.DeviceWarrantyStatus.purchaseDatePlaceholder')"
                                        :readonly="selectionsValid"
                                        type="date"
                                        v-model="purchaseDateInput"
                                />
                            </div>
                            <small class="form-text text-muted">{{ $t('bp.DeviceWarrantyStatus.subMessage') }}</small>
                        </div>
                        <div class="form-group" v-if="purchaseDateInput">
                            <label>{{$t('bp.DeviceWarrantyStatus.imeiLabel')}}<span class="text-danger">*</span></label>
                            <div class="loading-input-container">
                                <div class="loading-message" v-if="checkingSelections">{{ $t('bp.DeviceWarrantyStatus.checkingImei') }}</div>
                                <input
                                        class="form-control"
                                        :class="{'is-loading': checkingSelections}"
                                        :disabled="checkingSelections"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        :placeholder="$t('bp.DeviceWarrantyStatus.placeholder')"
                                        :readonly="selectionsValid"
                                        type="text"
                                        v-model="imeiInput"
                                />
                            </div>
                            <small class="cursor-pointer form-text text-underline" v-b-modal.imei-modal>{{ $t('bp.DeviceWarrantyStatus.howToFindImei') }}</small>
                        </div>
                    </div>

                </div>

                <!-- IMEI Instruction Modal -->
                <imei-modal></imei-modal>

                <!-- Out of Warranty Modal -->
                <out-of-warranty-modal></out-of-warranty-modal>

                <!-- Invalid IMEI Modal -->
                <imei-error-modal></imei-error-modal>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'deviceFaultType'}" class="btn btn-outline-secondary back-btn btn-lg" :class="{'disabled': checkingSelections}"><i class="fa fa-chevron-left text-sm mr-3"></i> {{ $t('bp.backButton') }}</router-link>
                    <button class="btn btn-primary btn-lg continue-btn icon-right ml-auto" @click="checkSelections" v-if="purchaseDateInput && imeiInput" :class="{'disabled': checkingSelections}">{{$t('bp.DeviceWarrantyStatus.checkImei')}} <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        data() {
            return {
                checkingSelections: false,
                imeiInput: null,
                imeiChecked: false,
                selectionsValid: false,
                purchaseDateInput: null
            }
        },

        mounted() {
            this.checkCanBeOnPage();

            if (this.purchaseDate) this.purchaseDateInput = this.purchaseDate;
            if (this.imei) this.imeiInput = this.imei;
        },

        computed: {
            ...mapGetters([
                "imei",
                "inWarrantyStatus",
                "purchaseDate"
            ])
        },

        methods: {
            ...mapActions([
                "checkBookingIsComplete",
                "setWarrantyDetails"
            ]),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.inWarrantyStatus) {
                        this.$router.push({name: 'deviceFaultType'});
                    }
                });
            },

            checkSelections() {
                this.checkingSelections = true;

                this.setWarrantyDetails({
                    purchaseDate: this.purchaseDateInput,
                    imei: this.imeiInput
                }).then(() => {
                    this.checkingSelections = false;
                    this.$router.push({name: 'repairSelect'});

                }).catch(e => {
                    this.checkingSelections = false;

                    if (e.response.data.code === "BK19") {
                        return this.$bvModal.show("oow-modal");
                    } else {
                        return this.$bvModal.show("imei-error-modal");
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>